import * as prismicH from '@prismicio/helpers';
import { RichText } from 'prismic-reactjs';
import { ErrorBoundary } from 'react-error-boundary';

import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import { ICheckoutPageContent } from '@monofront/types';
import CustomPrismicLink from '@components/CustomPrismicLink';
import logger from '@utils/logger';

interface IMessageWarningProps {
  pageContents?: Partial<ICheckoutPageContent>;
  UNSAFE_className?: string;
}

const MessageWarning: React.FC<IMessageWarningProps> = ({
  pageContents,
  UNSAFE_className,
}) => {
  if (!pageContents || !prismicH.asText(pageContents?.paymentWarningMessage))
    return null;

  // @TODO: refacto and use InformativeBox once removed from /Cart
  return (
    <>
      <ErrorBoundary
        fallbackRender={() => null}
        onError={(error) => {
          logger.error(
            '[checkout] An error occurred while rendering checkout warning message on Payment page.',
            {
              error,
            },
          );
        }}
      >
        <div
          className={`message-warning alert-info ${
            UNSAFE_className || ''
          } desktop:tw-mb-6`}
        >
          {pageContents.paymentWarningMessagePicto?.url ? (
            <div className="alert-info-image">
              <ResponsiveImage
                src={pageContents.paymentWarningMessagePicto.url}
                width={56}
                height={31}
                layout="fixed"
              />
            </div>
          ) : null}
          <div className="alert-info-text">
            <RichText
              render={pageContents.paymentWarningMessage}
              serializeHyperlink={CustomPrismicLink}
            />
          </div>
        </div>
      </ErrorBoundary>
      <style jsx>{`
        .alert-info {
          display: flex;
          align-items: center;
          margin-bottom: var(--space-6);
        }

        .alert-info-image {
          margin-right: var(--space-3);
        }

        .alert-info :global(strong) {
          color: var(--clr-secondary-1);
        }

         {
          /*  TODO: remove on this issue is done: https://gitlab.com/la-fourche/scrum/-/issues/1760 */
        }
        .alert-info-text :global(a) {
          transition: all 0.3s ease;
          color: var(--clr-link);
          text-decoration: underline;
          line-height: 1.375;
          cursor: pointer;
        }

        .alert-info-text :global(a):hover {
          opacity: var(--opacity-link-hover);
        }
      `}</style>
    </>
  );
};

export default MessageWarning;
